import baseService from './baseService';
import config from '../../config';

export default{
    search(params) {
        return baseService.get(config.API_LOCATION + 'list/search',params)
    },
    defaultSearch(params){
        return baseService.get(config.API_LOCATION + 'list/defaultSearch',params)
    },
    searchByType(params){
        return baseService.get(config.API_LOCATION + 'list/searchByType',params)
    }


}

